module.exports = __webpack_public_path__ + "img/chevron-1.ffeafe19.jpg";